import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import ReceiptIcon from '@material-ui/icons/Receipt';
import Tooltip from '@material-ui/core/Tooltip';
import { createReceiptPDF } from 'utilities/pdf';
import { useCache } from 'CacheProvider';
import { toastr } from 'react-redux-toastr';

export default function ReceiptPrinterButton({ data: inData, displayData }) {
  const { selectedUserGroupParams } = useCache();
  const receiptPrinterSettings = selectedUserGroupParams?.clientData?.facilitySettings?.receiptPrinterSettings || {};

  let sortedOrders = [...inData];
  if (displayData) {
    sortedOrders = displayData.map(({ data }) => {
      const orderId = data[0];
      const order = inData.find((order) => order.id === orderId);
      return order;
    });
  }

  const handleButtonClick = async () => {
    if (!receiptPrinterSettings.fields || !receiptPrinterSettings.width || !receiptPrinterSettings.height) {
      toastr.error('請先在帳號設定中設定出單機列印格式');
      return;
    }
    const pdfBytes = await createReceiptPDF(sortedOrders, receiptPrinterSettings);
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };

  return (
    <React.Fragment>
      <Tooltip title={'出單機列印'}>
        <IconButton
          size={'small'}
          onClick={handleButtonClick}
        >
          <ReceiptIcon />
        </IconButton>
      </Tooltip>
    </React.Fragment>
  );
}

ReceiptPrinterButton.propTypes = {
  data: PropTypes.array,
  displayData: PropTypes.array,
};
